module.exports = __webpack_public_path__ + "static/Repairers-02240ba7173205ea2d43d28c9d49ac49.svg";